import React, { useState, useEffect } from 'react';
import * as api from '../services/api';
import { Plus, Loader, Trash2, ChevronLeft } from 'lucide-react';
import LighthouseDetail from './LighthouseDetail';
import { LightbulbOff } from 'lucide-react';
import { Lightbulb } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';

const LighthousePage = ({ workerApiUrl, onBack, onSelectLighthouse, selectedLighthouse }) => {
    const [lighthouses, setLighthouses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    // const [selectedLighthouse, onSelectLighthouse] = useState(null);

    // Form state
    const [name, setName] = useState('');
    const [url, setUrl] = useState('');
    const [interval, setInterval] = useState('3');

    useEffect(() => {
        if (!selectedLighthouse) {
            fetchLighthouses();
        }
    }, [selectedLighthouse]);

    const fetchLighthouses = async () => {
        setIsLoading(true);
        try {
            const data = await api.getLighthouses(workerApiUrl);
            setLighthouses(data);
        } catch (err) {
            setError('Failed to fetch lighthouses.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        setError(null);
        if (!name || !url) {
            setError("Name and URL are required.");
            return;
        }
        setIsLoading(true);
        try {
            const newLighthouse = await api.createLighthouse(workerApiUrl, { name, url });
            setLighthouses([...lighthouses, newLighthouse]);
            setName('');
            setUrl('');
        } catch (err) {
            setError('Failed to create lighthouse.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (lighthouseId, e) => {
        e.stopPropagation(); // Prevent card click
        if (!window.confirm("Are you sure you want to delete this lighthouse?")) return;
        
        setIsLoading(true);
        try {
            await api.deleteLighthouse(workerApiUrl, lighthouseId);
            setLighthouses(lighthouses.filter(lh => lh.id !== lighthouseId));
        } catch (err) {
            setError('Failed to delete lighthouse.');
        } finally {
            setIsLoading(false);
        }
    };

    const StatusIndicator = ({ statusCode }) => {
        if (statusCode === null || statusCode === undefined) {
            return <div className="status-indicator pending" title="Pending"></div>;
        }
        const isUp = statusCode >= 200 && statusCode < 300;
        return <div className={`status-indicator ${isUp ? 'up' : 'down'}`} title={`Status: ${statusCode}`}></div>;
    };

    const getStatusColor = (item) => {
    // You can implement actual health check logic here
    return 'operational'; // 'operational', 'degraded', 'down'
  };

  const getStatusIcon = ( status) => {
   
    switch (Number(status)) {
      case (200<status<299):
        
          return <Lightbulb size={20} className="status-icon-operational" />;
        
      case (400<status<500):
        
          return <Lightbulb size={20} className="status-icon-degraded" />;
        
      case (500<status<600):
        
          return <LightbulbOff size={20} className="status-icon-down" />;
        
      default:
        return <LightbulbOff size={20} className="status-icon-down" />;
    }
  };
    if (selectedLighthouse) {
        return (
            <div className="lighthouse-detail-view">
                <header className="page-header">
                    <button onClick={() => onSelectLighthouse(null)} className="btn-secondary" disabled={isLoading}>
                        <ChevronLeft size={18} />
                        <span className="btn-text">Back to Lighthouses</span>
                    </button>
                </header>
                <LighthouseDetail lighthouse={selectedLighthouse} workerApiUrl={workerApiUrl} />
            </div>
        );
    }

    return (
        <div className="lighthouse-page">
            <header className="page-header">
                 {/* Header with breadcrumbs */}
                <div className="detail-header">
                  <div className="breadcrumbs">
                    <span onClick={onBack} className="breadcrumb-link breadcrumb-link-start">
                      <ArrowLeft size={18} />
                      Lighthouses
                    </span>
                    <span className="breadcrumb-separator">/</span>
                    <span className="breadcrumb-link breadcrumb-link-current ">{selectedLighthouse?.name || ''}</span>
                  </div>
                </div>

                <div className="create-lighthouse-form">
                  <form onSubmit={handleCreate} className="form-control">
                      <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Lighthouse Name" />
                      <input type="url" value={url} onChange={e => setUrl(e.target.value)} 
                      placeholder="https://example.com" required />
                      <select value={interval} onChange={e => setInterval(e.target.value)} required>
                        <option value="3">3 minutes</option>
                        <option value="5">5 minutes</option>
                        <option value="10">10 minutes</option>
                      </select>
                      <button type="submit" disabled={isLoading} className="btn-primary">
                          {isLoading ? <Loader size={18} className="animate-spin" /> : <Plus size={18} />}
                          <span className="btn-text">Add Lighthouse</span>
                      </button>
                  </form>
                </div>
            </header>
            
            {error && <p className="error-message">{error}</p>}

            <div className="lighthouses-grid">
                {lighthouses.map(lh => (
                    // <div key={lh.id} className="lighthouse-card" onClick={() => onSelectLighthouse(lh)}>
                    //     <div>
                    //         <div className="card-header">
                    //             <StatusIndicator statusCode={lh.last_status_code} />
                    //             <h3>{lh.name}</h3>
                    //         </div>
                    //         <p className="url-text">{lh.url}</p>
                    //     </div>

                    //     <div className="card-footer">
                    //         <span>{lh.last_status_code ? `Last Status: ${lh.last_status_code}` : 'Pending...'}</span>
                    //         <button onClick={(e) => handleDelete(lh.id, e)} disabled={isLoading} className="btn-icon btn-danger">
                    //            <Trash2 size={16} /> 
                    //         </button>
                    //     </div>
                    // </div>

                    <div 
                      key={lh.id} 
                      className="app-card"
                      onClick={() => onSelectLighthouse(lh)}
                    >
                    <div className="app-card-header">
                      <div className="app-card-header-left">
                        <h3>{lh.name}</h3>
                        <p>{lh.url.length > 30 ? lh.url.slice(0, 30) + '...' : lh.url}</p>
                      </div>
                      <div className="app-card-header-right">
                        {getStatusIcon(lh.last_status_code || 500)}
                      </div>
                    </div>
                    <div className="app-card-status">
                      <span className={`status-badge status-${lh.last_status_code || 'down'}`}>
                        {lh.last_status_code || 'down'}
                      </span>
                    </div>
                    <div className="app-card-meta">
                      <small>Created {new Date(lh.created_at).toLocaleDateString()}</small>
                      <button onClick={(e) => handleDelete(lh.id, e)} disabled={isLoading} className="btn-icon btn-danger">
                        <Trash2 size={16} /> 
                      </button>
                    </div>
                  </div>
                ))}
            </div>
        </div>
    );
};

export default LighthousePage;
